import axiosInstance from './axiosInterceptor';

export const apiRoute = {
  auth: {
    loginUrl: '/auth/login',
    profileUrl: '/auth/profile'
  },
  master: {
    foodTypeUrl: '/master/food-type',
    exportFoodTypeUrl: '/master/export-food-type',
    blogCategoryUrl: '/master/blog-category',
    planCategoryUrl: '/master/plan-category',
    tierUrl: '/master/tier',
    dietaryUrl: '/master/dietary-preference',
    exerciseUrl: '/master/exercise-type',
    exportExerciseUrl: '/master/export-exercise-type',
    goalUrl: '/master/goal'
  },
  coach: {
    coachCategoryUrl: '/coach/category',
    coachKycStatusUrl: '/coach/approved-kyc-status',
    markCoachCategoryUrl: '/coach/mark-popular-coach-category',
    coachesUrl: '/coach/coach-profile',
    coachByIdUrl: '/coach/coach-details',
    allCoachUrl: '/coach/all-coach-list',
    coachStatusUrl: '/coach/coach-profile-status',
    allCoachTierUrl: '/coach/tier-list',
    coachRatingUrl: '/coach/coach-rating-review'
  },
  consultation: {
    consultationsUrl: '/booking/booking-list',
    consultationByIdUrl: '/booking/booking-details',
    consultationDietUrl: '/booking/diet-chart',
    consultationRecipeUrl: '/booking/recipe-details',
    consultationWorkoutUrl: '/booking/workout-plan',
    consultationFollowUpUrl: '/booking/followup-list',
    consultationAddFollowUpUrl: '/booking/followup',
    consultationFollowUpStatusUrl: '/booking/followup-status'
  },
  cms: {
    cmsUrl: '/cms/content',
    faqUrl: '/cms/faq',
    aboutUrl: '/cms/about-us',
    bannerUrl: '/feature/banner',
    allUserUrl: '/feature/all-user',
    storyUrl: '/feature/story',
    blogUrl: '/feature/blog',
    storyStatusUrl: '/feature/story-status',
    blogStatusUrl: '/feature/blog-status',
    blogTopMarkUrl: '/feature/mark-top',
    blogByIdUrl: '/feature/blog-details'
  },
  userReport: {
    userReportUrl: '/report/get-all-user-report',
    userReportDetailsUrl: '/report/get-user-report-details',
    editUserReportUrl: '/report/update-report'
  },
  user: {
    userListUrl: '/feature/all-users-list',
    userDetailUrl: '/feature/user-details',
    userAddressUrl: '/feature/user-addresses',
    userConsultationUrl: '/booking/consultation',
    userStatusUrl: '/user/user-status'
  },
  plan: {
    planUrl: '/feature/plan',
    planStatusUrl: '/feature/plan-status',
    planByIdUrl: '/feature/plan-details'
  },
  gym: {
    gymsUrl: '/feature/on-boarding-gym',
    gymStatusUrl: '/feature/on-boarding-gym-status',
    verticalBannerUrl: '/feature/gym-vertical-banner'
  },
  dashboard: {
    counterUrl: '/feature/dashboard-counter',
    consultationStatusUrl: '/feature/dashboard-consultation-status',
    coachKycUrl: '/feature/dashboard-coach-kyc',
    platformRegistrationsUrl: '/feature/dashboard-platform-registrations',
    yearlyConsultationUrl: '/feature/dashboard-yearly-consultation',
    recentCoachesUrl: '/feature/dashboard-recent-coachs',
    recentGymsUrl: '/feature/dashboard-recent-gyms',
    recentUsersUrl: '/feature/dashboard-recent-users',
    revenueOverviewUrl: '/feature/dashboard-revenue-overview',
    subscriptionPlanTakenUrl: '/feature/dashboard-subscription-plan-taken',
    bestPerformingCoachesUrl: '/feature/dashboard-best-performing-coaches'
  },
  uploadFile: {
    uploadFoodUrl: '/feature/food-excel-upload',
    uploadExerciseUrl: '/feature/exercise-excel-upload'
  }
};

//  authentication
export const adminLogin = (data) => axiosInstance.post(apiRoute.auth.loginUrl, data);
export const fetchAdminProfile = () => axiosInstance.get(apiRoute.auth.profileUrl);

//Food Type
export const FOOD_TYPE = {
  fetchFoodType: (params) => axiosInstance.get(apiRoute.master.foodTypeUrl, { params }),
  CreateFoodType: (body) => axiosInstance.post(apiRoute.master.foodTypeUrl, body),
  exportFoodType: () => axiosInstance.post(apiRoute.master.exportFoodTypeUrl),
  updateFoodType: (body) => axiosInstance.put(apiRoute.master.foodTypeUrl, body),
  removeFoodType: (body) => axiosInstance.delete(apiRoute.master.foodTypeUrl, { data: body })
};

//Blog Category
export const BLOG_CATEGORY = {
  fetchBlogCategory: (params) => axiosInstance.get(apiRoute.master.blogCategoryUrl, { params }),
  CreateBlogCategory: (body) => axiosInstance.post(apiRoute.master.blogCategoryUrl, body),
  updateBlogCategory: (body) => axiosInstance.put(apiRoute.master.blogCategoryUrl, body),
  removeBlogCategory: (body) => axiosInstance.delete(apiRoute.master.blogCategoryUrl, { data: body })
};

//Plan Category
export const PLAN_CATEGORY = {
  fetchPlanCategory: (params) => axiosInstance.get(apiRoute.master.planCategoryUrl, { params }),
  CreatePlanCategory: (body) => axiosInstance.post(apiRoute.master.planCategoryUrl, body),
  updatePlanCategory: (body) => axiosInstance.put(apiRoute.master.planCategoryUrl, body),
  removePlanCategory: (body) => axiosInstance.delete(apiRoute.master.planCategoryUrl, { data: body })
};

//Tier
export const TIER = {
  fetchTier: (params) => axiosInstance.get(apiRoute.master.tierUrl, { params }),
  CreateTier: (body) => axiosInstance.post(apiRoute.master.tierUrl, body),
  updateTier: (body) => axiosInstance.put(apiRoute.master.tierUrl, body),
  removeTier: (body) => axiosInstance.delete(apiRoute.master.tierUrl, { data: body })
};

//dietary-preference
export const DIETARY_PREFERENCE = {
  fetchDietaryPreference: (params) => axiosInstance.get(apiRoute.master.dietaryUrl, { params }),
  CreateDietaryPreference: (body) => axiosInstance.post(apiRoute.master.dietaryUrl, body),
  updateDietaryPreference: (body) => axiosInstance.put(apiRoute.master.dietaryUrl, body),
  removeDietaryPreference: (body) => axiosInstance.delete(apiRoute.master.dietaryUrl, { data: body })
};

//exercise type
export const EXERCISE_TYPE = {
  fetchExerciseType: (params) => axiosInstance.get(apiRoute.master.exerciseUrl, { params }),
  CreateExerciseType: (body) => axiosInstance.post(apiRoute.master.exerciseUrl, body),
  exportExerciseType: (body) => axiosInstance.post(apiRoute.master.exportExerciseUrl, body),
  updateExerciseType: (body) => axiosInstance.put(apiRoute.master.exerciseUrl, body),
  removeExerciseType: (body) => axiosInstance.delete(apiRoute.master.exerciseUrl, { data: body })
};

//Goals
export const GOAL = {
  fetchGoals: (params) => axiosInstance.get(apiRoute.master.goalUrl, { params }),
  CreateGoal: (body) => axiosInstance.post(apiRoute.master.goalUrl, body),
  updateGoal: (body) => axiosInstance.put(apiRoute.master.goalUrl, body),
  removeGoal: (body) => axiosInstance.delete(apiRoute.master.goalUrl, { data: body })
};

// Coach Category
export const COACH_CATEGORY = {
  fetchCoachCategory: (params) => axiosInstance.get(apiRoute.coach.coachCategoryUrl, { params }),
  CreateCoachCategory: (body) => axiosInstance.post(apiRoute.coach.coachCategoryUrl, body),
  markCoachCategory: (body) => axiosInstance.post(apiRoute.coach.markCoachCategoryUrl, body),
  updateCoachCategory: (body) => axiosInstance.put(apiRoute.coach.coachCategoryUrl, body),
  removeCoachCategory: (body) => axiosInstance.delete(apiRoute.coach.coachCategoryUrl, { data: body })
};

// CMS
export const CMS = {
  fetchCms: (params) => axiosInstance.get(apiRoute.cms.cmsUrl, { params }),
  upsertCms: (body) => axiosInstance.put(apiRoute.cms.cmsUrl, body),
  createCms: (body) => axiosInstance.post(apiRoute.cms.cmsUrl, body)
};
// FAQ
export const FAQ = {
  fetchFaq: (params) => axiosInstance.get(apiRoute.cms.faqUrl, { params }),
  createFaq: (body) => axiosInstance.post(apiRoute.cms.faqUrl, body),
  updateFaq: (body) => axiosInstance.put(apiRoute.cms.faqUrl, body),
  removeFaq: (body) => axiosInstance.delete(apiRoute.cms.faqUrl, { data: body })
};

// Banner
export const BANNER = {
  fetchBanner: (params) => axiosInstance.get(apiRoute.cms.bannerUrl, { params }),
  createBanner: (body) => axiosInstance.post(apiRoute.cms.bannerUrl, body),
  updateBanner: (body) => axiosInstance.put(apiRoute.cms.bannerUrl, body),
  removeBanner: (body) => axiosInstance.delete(apiRoute.cms.bannerUrl, { data: body })
};

// Story
export const STORY = {
  fetchStory: (params) => axiosInstance.get(apiRoute.cms.storyUrl, { params }),
  fetchStoryAllUser: (params) => axiosInstance.get(apiRoute.cms.allUserUrl, { params }),
  createStory: (body) => axiosInstance.post(apiRoute.cms.storyUrl, body),
  updateStory: (body) => axiosInstance.put(apiRoute.cms.storyUrl, body),
  updateStoryStatus: (body) => axiosInstance.patch(apiRoute.cms.storyStatusUrl, body),
  removeStory: (body) => axiosInstance.delete(apiRoute.cms.storyUrl, { data: body })
};
// Blog
export const BLOG = {
  fetchBlog: (params) => axiosInstance.get(apiRoute.cms.blogUrl, { params }),
  fetchBlogById: (id) =>
    axiosInstance.get(apiRoute.cms.blogByIdUrl, {
      params: { blogId: id }
    }),
  createBlog: (body) => axiosInstance.post(apiRoute.cms.blogUrl, body),
  updateBlog: (body) => axiosInstance.put(apiRoute.cms.blogUrl, body),
  removeBlog: (body) => axiosInstance.delete(apiRoute.cms.blogUrl, { data: body }),
  changeBlogStatus: (body) => axiosInstance.patch(apiRoute.cms.blogStatusUrl, body),
  changeBlogTop: (body) => axiosInstance.patch(apiRoute.cms.blogTopMarkUrl, body)
};

// About Us
export const ABOUT_US = {
  fetchAboutUs: (params) => axiosInstance.get(apiRoute.cms.aboutUrl, { params }),
  createAboutUs: (body) => axiosInstance.post(apiRoute.cms.aboutUrl, body),
  updateAboutUs: (body) => axiosInstance.put(apiRoute.cms.aboutUrl, body),
  removeAboutUs: (body) => axiosInstance.delete(apiRoute.cms.aboutUrl, { data: body })
};

// User Report
export const USER_REPORT = {
  fetchUserReports: (params) => axiosInstance.get(apiRoute.userReport.userReportUrl, { params }),
  fetchUserReportById: (params) => axiosInstance.get(apiRoute.userReport.userReportDetailsUrl, { params }),
  updateUserReport: (body) => axiosInstance.put(apiRoute.userReport.editUserReportUrl, body)
};

// Users
export const USERS = {
  fetchUsers: (params) => axiosInstance.get(apiRoute.user.userListUrl, { params }),
  fetchUserById: (params) => axiosInstance.get(apiRoute.user.userDetailUrl, { params }),
  fetchUserAddress: (params) => axiosInstance.get(apiRoute.user.userAddressUrl, { params }),
  fetchUserConsultations: (params) => axiosInstance.get(apiRoute.user.userConsultationUrl, { params }),
  changeUserStatus: (body) => axiosInstance.patch(apiRoute.user.userStatusUrl, body)
};

// Coaches
export const COACHES = {
  fetchCoaches: (params) => axiosInstance.get(apiRoute.coach.coachesUrl, { params }),
  fetchCoachRating: (params) => axiosInstance.get(apiRoute.coach.coachRatingUrl, { params }),
  fetchCoachById: (params) => axiosInstance.get(apiRoute.coach.coachByIdUrl, { params }),
  fetchAllCoach: (params) => axiosInstance.get(apiRoute.coach.allCoachUrl, { params }),
  fetchAllCoachTier: () => axiosInstance.get(apiRoute.coach.allCoachTierUrl),
  CreateCoaches: (body) => axiosInstance.post(apiRoute.coach.coachesUrl, body),
  changeCoachStatus: (body) => axiosInstance.patch(apiRoute.coach.coachStatusUrl, body),
  changeCoachKycStatus: (body) => axiosInstance.patch(apiRoute.coach.coachKycStatusUrl, body)
};

export const CONSULTATION = {
  fetchConsultations: (params) => axiosInstance.get(apiRoute.consultation.consultationsUrl, { params }),
  fetchConsultationById: (params) => axiosInstance.get(apiRoute.consultation.consultationByIdUrl, { params }),
  fetchConsultationDiet: (params) => axiosInstance.get(apiRoute.consultation.consultationDietUrl, { params }),
  fetchConsultationRecipe: (params) => axiosInstance.get(apiRoute.consultation.consultationRecipeUrl, { params }),
  fetchConsultationWorkout: (params) => axiosInstance.get(apiRoute.consultation.consultationWorkoutUrl, { params }),
  fetchConsultationFollowUp: (params) => axiosInstance.get(apiRoute.consultation.consultationFollowUpUrl, { params }),
  createConsultationFollowUp: (body) => axiosInstance.post(apiRoute.consultation.consultationAddFollowUpUrl, body),
  consultationFollowUpStatus: (body) => axiosInstance.patch(apiRoute.consultation.consultationFollowUpStatusUrl, body)
};

// Subsciption Plan
export const PLAN = {
  fetchPlans: (params) => axiosInstance.get(apiRoute.plan.planUrl, { params }),
  fetchPlanById: (params) => axiosInstance.get(apiRoute.plan.planByIdUrl, { params }),
  createPlan: (body) => axiosInstance.post(apiRoute.plan.planUrl, body),
  updatePlan: (body) => axiosInstance.put(apiRoute.plan.planUrl, body),
  updatePlanStatus: (body) => axiosInstance.patch(apiRoute.plan.planStatusUrl, body),
  removePlan: (body) => axiosInstance.delete(apiRoute.plan.planUrl, { data: body })
};

// Gym onboarding
export const GYM = {
  fetchGyms: (params) => axiosInstance.get(apiRoute.gym.gymsUrl, { params }),
  createGym: (body) => axiosInstance.post(apiRoute.gym.gymsUrl, body),
  updateGym: (body) => axiosInstance.put(apiRoute.gym.gymsUrl, body),
  updateGymStatus: (body) => axiosInstance.post(apiRoute.gym.gymStatusUrl, body),
  removeGym: (body) => axiosInstance.delete(apiRoute.gym.gymsUrl, { data: body })
};

// Gym vertical banners
export const GYM_VERTICAL_BANNER = {
  fetchBanners: (params) => axiosInstance.get(apiRoute.gym.verticalBannerUrl, { params }),
  createBanner: (body) => axiosInstance.post(apiRoute.gym.verticalBannerUrl, body),
  updateBanner: (body) => axiosInstance.put(apiRoute.gym.verticalBannerUrl, body),
  removeBanner: (body) => axiosInstance.delete(apiRoute.gym.verticalBannerUrl, { data: body })
};

// Dashboard analytics
export const DASHBOARD = {
  fetchCounter: () => axiosInstance.get(apiRoute.dashboard.counterUrl),
  fetchConsultationStatus: () => axiosInstance.get(apiRoute.dashboard.consultationStatusUrl),
  fetchCoachKyc: () => axiosInstance.get(apiRoute.dashboard.coachKycUrl),
  fetchPlatformRegistrations: () => axiosInstance.get(apiRoute.dashboard.platformRegistrationsUrl),
  fetchYearlyConsultation: () => axiosInstance.get(apiRoute.dashboard.yearlyConsultationUrl),
  fetchRecentCoaches: () => axiosInstance.get(apiRoute.dashboard.recentCoachesUrl),
  fetchRecentGyms: () => axiosInstance.get(apiRoute.dashboard.recentGymsUrl),
  fetchRecentUsers: () => axiosInstance.get(apiRoute.dashboard.recentUsersUrl),
  fetchRevenueOverview: () => axiosInstance.get(apiRoute.dashboard.revenueOverviewUrl),
  fetchSubscriptionPlanTaken: () => axiosInstance.get(apiRoute.dashboard.subscriptionPlanTakenUrl),
  fetchBestPerformingCoaches: () => axiosInstance.get(apiRoute.dashboard.bestPerformingCoachesUrl)
};

// Upload File
export const UPLOAD_FOOD = {
  fetchUploadFood: (params) => axiosInstance.get(apiRoute.uploadFile.uploadFoodUrl, { params }),
  createUploadFood: (body) => axiosInstance.post(apiRoute.uploadFile.uploadFoodUrl, body)
};

// Upload File
export const UPLOAD_EXERCISE = {
  fetchUploadExercise: (params) => axiosInstance.get(apiRoute.uploadFile.uploadExerciseUrl, { params }),
  createUploadExercise: (body) => axiosInstance.post(apiRoute.uploadFile.uploadExerciseUrl, body)
};
